var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "border",
    { attrs: { green: _vm.green } },
    [
      _vm.title
        ? _c("border-header", { attrs: { green: _vm.green, title: _vm.title } })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }